import { ReactNode, useMemo } from "react";
import { ThemeProvider as SCThemeProvider } from "styled-components";
import getTheme, { Theme } from "./themes";
import { SCHEMES } from "./use-color-scheme";
import {
  generateCSSCustomProperties,
  generateZiPalette,
} from "./tailwind-palette-generator";

export default function ThemeProvider({
  children,
  projectTheme,
  themeName,
}: {
  children: ReactNode;
  projectTheme?: any;
  themeName?: string;
}) {
  const rootQualifier = themeName ? `.${themeName}` : ":root";
  const darkQualifier = themeName
    ? `.dark.${themeName}, .dark .${themeName}`
    : ".dark";
  const scheme: SCHEMES = SCHEMES.LIGHT;

  const theme = useMemo<Theme>(
    () => projectTheme ?? getTheme(scheme),
    [projectTheme, scheme]
  );

  const cssProperties = useMemo<string>(() => {
    const palette = generateZiPalette(theme.app.colors);
    const cssProperties = generateCSSCustomProperties(palette);
    return cssProperties;
  }, [theme.app.colors]);

  return (
    <SCThemeProvider theme={theme}>
      <style global jsx>{`
        ${rootQualifier} {
          ${cssProperties}

          --zi-pageWidth: ${theme.app.pageWidth}px;
        }

        /* These are exactly the same as above... eventually we'll support dark mode. */
        ${darkQualifier} {
          ${cssProperties}

          --zi-pageWidth: ${theme.app.pageWidth}px;
        }
      `}</style>

      {themeName ? <div className={themeName}>{children}</div> : children}
    </SCThemeProvider>
  );
}
